export const kit8Data = {
    name: 'kit8',
    baseUrl: "/samples/drums/kit8/",
    parts: ["kick", "snare", "hihat"],
    samples: {
        C4: "kick.mp3",
        D4: "snare.mp3",
        E4: "hihat.mp3",
    }
}